import { screenSize, whiteColor } from '@app/styles';
import styled from 'styled-components';

export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.maxMobile}) {
    background: ${whiteColor};
  }
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-center: center;
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 190px);
    height: calc(100vh - 60px);
    margin: auto;
    margin-top: 60px;
    margin-bottom: 180px;
  }
`;

export const ErrorMessage = styled.div`
  margin: auto;
  font-size: 20px;
  font-weight: bold;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
